/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventResponse } from '../../models/event-response';

export interface EventsControllerDeleteThumbnail$Params {
  id: string;
}

export function eventsControllerDeleteThumbnail(http: HttpClient, rootUrl: string, params: EventsControllerDeleteThumbnail$Params, context?: HttpContext): Observable<StrictHttpResponse<EventResponse>> {
  const rb = new RequestBuilder(rootUrl, eventsControllerDeleteThumbnail.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EventResponse>;
    })
  );
}

eventsControllerDeleteThumbnail.PATH = '/events/admin/{id}/thumbnail';
